module.exports = __webpack_public_path__ + "img/OKRFilters.390a786a.png";